const ChangePassword = {

    // PAGE HEADER
    "tagline": "Change Password",

    // FIELDS
    "old_pass": "Old Password",
    "new_pass": "New Password",
    "confirm_pass": "Confirm Password",

    // TOAST
    "success_add": "Password Changed Successfully!!..",
    "server_error": "Server error!!..",
    "wrong": "Something went wrong!!..",

    // ERROR
    "error_old_pass": "Enter Old Password",
    "error_new_pass": "Enter New Password",
    "error_confirm_pass": "Enter Confirm Password",
    "error_pass_match": "Confirm Password doesn't match",

}

export default ChangePassword;